export default __webpack_public_path__ + "static/media/zero_or_one.6b0e7d86.gif";